import { ConfirmDialog } from '@/_shared/components/ConfirmDialog';

import type { PendingAction } from './types';

interface SlackConfirmDialogProps {
  pending: PendingAction | null;
  title: string | undefined;
  description: string | undefined;
  confirmLabel: string | undefined;
  actionPending: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export function SlackConfirmDialog({
  pending,
  title,
  description,
  confirmLabel,
  actionPending,
  onClose,
  onConfirm,
}: SlackConfirmDialogProps): React.ReactElement {
  const unbind = pending?.variant === 'unbind';
  return (
    <ConfirmDialog
      open={pending !== null}
      onOpenChange={(next) => !next && onClose()}
      title={title}
      description={description}
      confirmLabel={confirmLabel}
      testIds={{
        content: unbind ? 'unbind-channel-dialog' : 'unlink-user-dialog',
        confirm: unbind ? 'confirm-unbind-channel' : 'confirm-unlink-user',
      }}
      loading={actionPending}
      onConfirm={onConfirm}
    />
  );
}
